import { TranslationMap } from '@trimble-gcs/i18n-types';

export function scan3dDetailTranslations() {
  return {
    breadcrumbs: {
      details: {
        text: $localize`:@@scan3dDetail.breadcrumbs.details:Details`,
        desc: 'Title of point cloud details panel.',
      },
    },
    properties: {
      text: $localize`:@@scan3dDetail.properties:Properties`,
      desc:
        'Title for the properties tab for a single point cloud selection ' +
        'in scan data list or the 3d scan data detail panel.',
    },
    styling: {
      text: $localize`:@@scan3dDetail.styling:Styling`,
      desc:
        'Title for the styling tab when viewing the detail for a point cloud ' +
        'selection in the 3d scan data list.',
    },
  } satisfies TranslationMap;
}
